class PricingContainer extends HTMLElement {
  constructor() {
    super();
    this.currentId = null;
    this.product = null;
    this.variant = null;
    this.plan = null;
    this.subscribed = false;
    this.qty = 1;
  }

  connectedCallback() {
    if (this.closest('cart-recommendations')) {
      // console.debug('cart-recommendations', { this: this });
      // changeHandler is in cart-recommendations.js
    } else if (
      this.closest('pricing-line') &&
      this.closest('pricing-line').parentElement?.querySelector('free-shipping-callout')
    ) {
      // console.debug('top pricing-line', { this: this });
      // listen to variant change if atc type is multi, then intevene
      // or so the plan was, but it appears the pricing line gets re-rendered at variant change
      this.subscribed = document.querySelector('[id*="MainProduct"]')
        ? document.querySelector('[id*="MainProduct"]').dataset.subscribed === 'true'
        : true;

      this.setProduct(window.pdp.currentVariant);
      this.updatePrices();
    } else if (window.location.pathname === '/pages/bundle') {
      subscribe(PUB_SUB_EVENTS.planChange, (e) => {
        let lastValue = this.subscribed;
        this.subscribed = e.isSubscribed;
        if (lastValue !== this.subscribed) {
          this.updatePrices();
        }
      });
    }
  }

  static getProduct() {
    return this.product;
  }

  setProduct(product) {
    if (!product) return;
    this.currentId = product.id;

    if (window.Shopify?.pageType === 'product') {
      if (window.pdp?.product_object) {
        this.product = window.pdp.product_object;
      }
    }

    if (this.product?.id !== this.currentId) {
      this.variant = product;
    }

    // Set plan price
    if (this.variant && this.variant.selling_plan_allocations?.length > 0) {
      this.plan = this.variant.selling_plan_allocations[0];
    } else {
      if (this.product && this.product.selling_plan_groups) {
        if (this.product.selling_plan_groups[0] && this.product.selling_plan_groups[0].selling_plans.length > 0) {
          let planObj = this.product.selling_plan_groups[0].selling_plans[0];
          if (planObj.price_adjustments[0]) {
            let adjustments = planObj.price_adjustments[0];
            if (adjustments.value_type === 'percentage') {
              this.plan = { price: this.product.price - (this.product.price / 100) * adjustments.value };
            }
          }
        }
      }
    }
  }

  setQty(qty) {
    if (this.product?.hasOwnProperty('id') && qty) {
      this.qty = parseInt(qty);
      return this.qty;
    }
  }

  updatePrices() {
    let isVariant = this.variant !== null;
    let currentProduct = this.product;

    // console.debug({ isVariant, variant: this.variant, product: this.product })

    if (isVariant) {
      currentProduct = this.variant;
    }

    if (currentProduct) {
      const productId = currentProduct.featured_image?.product_id | currentProduct.id;
      const sale = this.querySelector('.price__sale');

      if (!sale) return;

      let isSubscribed = this.subscribed;
      if (window.Shopify?.pageType === 'product')
        isSubscribed = document.querySelector('[id*="MainProduct"]')
          ? document.querySelector('[id*="MainProduct"]').dataset.subscribed === 'true'
          : false;
      const priceElement = sale.querySelector('.price-item.price-item--last');
      const compPriceElement = sale.querySelector('.price-item.price-item--regular');
      const regularPriceElement = this.querySelector('.price__regular');

      let price = ((currentProduct.price * this.qty) / 100).toFixed(0);

      priceElement.dataset.productId = productId;
      if (isSubscribed) {
        price = ((this.plan.price * this.qty) / 100).toFixed(0);
      }
      // console.debug({ currentId: this.currentId, currentProduct, isSubscribed, price })

      priceElement.innerText = `$${price}`;

      if (compPriceElement) {
        compPriceElement.dataset.productId = productId;
        compPriceElement.innerText = `$${((currentProduct.compare_at_price * this.qty) / 100).toFixed(0)}`;
      }

      regularPriceElement.querySelector('.price-item.price-item--regular').innerText = `$${price}`;

      return 'Displayed prices updated';
    } else {
      return 'No product set, display values not updated';
    }
  }
}
customElements.define('price-container', PricingContainer);

class MainPricingLine extends HTMLElement {
  constructor() {
    super();
    this.product = null;
    this.plan = null;
  }

  connectedCallback() {
    if (window.location.pathname === '/pages/bundle') {
      this.subscribed = true;

      const id = this.dataset.variantId;
      if (!id) return;

      const variant = JSON.parse(
        this.closest('li[product-id]').querySelector('script.default-product-variant').textContent
      );

      this.setProduct(variant);
      this.updateAll();
    } else if (window.Shopify?.pageType === 'product' && window.pdp?.currentVariant) {
      if (this.closest('product-info .product__info-container')) {
        this.setProduct(window.pdp.currentVariant);
        this.updateAll();
      }
    }

    if (window.Shopify?.pageType === 'product' || window.location.pathname === '/pages/bundle') {
      subscribe(PUB_SUB_EVENTS.planChange, (e) => {
        let lastValue = this.subscribed;
        this.subscribed = e.isSubscribed;

        if (lastValue !== this.subscribed) {
          if (e.source === 'dynamic-atc-component') {
            this.setProduct(window.variant);
          }
          this.updateAll();
        }
      });
    }
  }

  setProduct(product) {
    // TODO: look for a way to optimize this further

    if (product && product.hasOwnProperty('id')) {
      this.querySelector('price-container')?.setProduct(this.product);
      this.product = product;
      this.plan = this.querySelector('price-container').plan;

      this.querySelector('price-container')?.updatePrices();
      this.setSubscriptionStatus();
    }

    return;
  }

  setSubscriptionStatus() {
    if (window.Shopify?.pageType === 'product') {
      this.subscribed = document.querySelector('[id*="MainProduct"]')
        ? document.querySelector('[id*="MainProduct"]').dataset.subscribed === 'true'
        : true;
    }
  }

  updatePrices() {
    if (this.product) {
      this.setProduct(this.product);
    }
  }

  updateAll() {
    this.updatePrices();
    this.updatePercentSavings();
    this.updateShipping();
  }

  updatePercentSavings() {
    if (this.product) {
      if (!this.product.compare_at_price) return;

      const container = this.querySelector('.pricing-line--right');
      const calculateSavings = (price, compPrice) => Math.round(((compPrice - price) / compPrice) * 100);

      let price = this.product.price;
      let compareAtPrice = this.product.compare_at_price;

      if (this.subscribed) {
        if (
          this.product.hasOwnProperty('selling_plan_allocations') &&
          Array.isArray(this.product.selling_plan_allocations)
        ) {
          if (this.plan) {
            price = this.plan.price;
          }
        }
      }

      let savingsPercent = calculateSavings(price, compareAtPrice);
      // console.debug({ product: this.product, price, compareAtPrice, planPrice: this.plan?.price })

      if (savingsPercent) {
        container.innerHTML = `<p class="percent-savings" style="display: inline-block">-${savingsPercent}%</p>`;
        if (window.Shopify?.pageType === 'product') {
          if (
            this.subscribed &&
            document.getElementById('pdp-header-countdown-timer') &&
            document.querySelector('#pdp-header-countdown-timer .timer-heading').innerHTML.match(/\d+(\.\d+)?%/)
          ) {
            document.querySelector('#pdp-header-countdown-timer .timer-heading').innerHTML = document
              .querySelector('#pdp-header-countdown-timer .timer-heading')
              .innerHTML.replace(/\d+(\.\d+)?%/, `${savingsPercent}%`);
          }
        }
        return 'Percent savings value updated';
      } else {
        return;
      }
    } else {
      return this.productNotSet();
    }
  }

  updateShipping() {
    const container = this.querySelector('.plus-shipping');

    if (!container) return;

    if (this.subscribed === true) {
      container.querySelector('span.free-shipping--label').classList.remove('display-off');
    } else {
      container.querySelector('span.free-shipping--label').classList.add('display-off');
    }
  }

  productNotSet() {
    return 'No product set, display values not updated';
  }
}
customElements.define('pricing-line', MainPricingLine);

class VariantPickerBigButtons extends HTMLElement {
  connectedCallback() {
    this.isSplitOptions = this.querySelector('[data-split-options-member]') ? true : false;

    if (this.isSplitOptions) {
      this.originalOptionsData = JSON.parse(this.querySelector('[data-original-options]').textContent);
      this.originalSelectOptions = Array.from(this.originalOptionsData, (v) => v.name);
      this.hiddenInput = this.querySelector('[data-split-options-original-input] input');
    }
  }

  updateUrlParam() {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', this.currentVariant.id);
    window.history.pushState(null, '', url.toString());
  }

  updateVariantData() {
    this.variantData =
      window.pdp?.variants ||
      this.variantData ||
      JSON.parse(document.querySelector('script[data-product-variants]').textContent);

    this.options = Array.from(
      this.closest('variant-selects').querySelectorAll('fieldset input:checked, select'),
      (el) => el.value
    );

    if (this.isSplitOptions) {
      // get the selected options and values
      let inputChecked = document.querySelectorAll('[data-split-options-member] input:checked');
      let optionValues = Array.from(inputChecked, (el) => {
        return el.value;
      });
      let optionIndex = Number(document.querySelector('[data-split-options-member]').dataset.optionIndex) - 1;

      const matchSelectOption = (s) =>
        this.originalSelectOptions.find((v) => {
          return v == s;
        });

      this.selectedValuesStr = optionValues.join(' + ');
      if (!matchSelectOption(this.selectedValuesStr)) this.selectedValuesStr = optionValues.reverse().join(' + ');

      let optionValueId = this.originalOptionsData.find((v) => v.name === this.selectedValuesStr).id;
      this.hiddenInput.value = this.selectedValuesStr;
      this.hiddenInput.dataset.optionValueId = optionValueId;

      console.debug('VariantPickerBigButtons.getVariantData()', {
        selectedValues: this.selectedValuesStr,
        inputChecked,
        optionValues,
        optionValueId,
        optionIndex,
      });

      this.options.splice(optionIndex, 1, this.selectedValuesStr);
    }

    this.currentVariant = this.variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    console.debug('VariantPickerBigButtons.getVariantData()', {
      currentVariant: this.currentVariant,
      variantData: this.variantData,
    });

    if (this.currentVariant) {
      this.closest('variant-selects').querySelector('[data-selected-variant]').textContent = JSON.stringify(
        this.currentVariant
      );
      if (window.Shopify?.pageType === 'product') {
        window.pdp && (window.pdp.currentVariant = this.currentVariant);
      }
    } else {
    }

    return this.variantData;
  }
}
customElements.define('variant-picker-big-buttons', VariantPickerBigButtons);

class VariantOptionButtons extends HTMLElement {
  connectedCallback() {
    this.isSplitOptions = this.dataset.splitOptionsMember ? true : false;
    this.lastVariantId = null;

    if (this.isSplitOptions) {
      this.addEventListener('click', this.clickHandlerSplitOptions.bind(this));
    } else {
      this.addEventListener('click', this.clickHandler.bind(this));
    }
  }

  disconnectedCallback() {
    if (this.isSplitOptions) {
      this.removeEventListener('click', this.clickHandlerSplitOptions);
    } else {
      this.removeEventListener('click', this.clickHandler);
    }
  }

  clickHandler(e) {
    const { target } = e;
    e.stopPropagation();

    if (target.tagName === 'LABEL' || target.closest('label')) {
      if (target.closest('label').classList.contains('form__label')) return this.triggerOptionInfo(target);

      let inputId = target.htmlFor || target.closest('label').htmlFor;
      let inputElement = target.closest('label').previousElementSibling;

      this.querySelectorAll(`input:checked:not([id="${inputId}"])`).forEach((el) => {
        if (el.id === inputId) return;
        el.removeAttribute('checked');
        el.checked = false;
      });

      if (inputElement.tagName === 'INPUT') {
        inputElement.checked = true;
        target.closest(`.product-form__input`).dataset.selectedValue = inputElement.value;
        target.closest(`.product-form__input`).querySelector('.form__label span').innerHTML = inputElement.value;
      }

      target.closest('variant-picker-big-buttons').updateVariantData();
      target.closest('variant-selects').dispatchEvent(new Event('change'));
    }
  }

  clickHandlerSplitOptions(e) {
    const { target } = e;

    e.preventDefault();
    e.stopPropagation();

    if (target.tagName === 'LABEL' || target.closest('label')) {
      if (target.closest('label').classList.contains('form__label')) return this.triggerOptionInfo(target);

      let inputElement = target.closest('label').previousElementSibling;
      inputElement.checked = true;
      this.querySelector('.dropdown--selected-option').innerHTML = inputElement.value;

      this.dataset.selectedValue = inputElement.value;

      target.closest('variant-picker-big-buttons').updateVariantData();
      if (window.Shopify?.pageType === 'product') {
        target.closest('variant-picker-big-buttons').updateUrlParam();
        target.closest('variant-selects').dispatchEvent(new Event('change'));
      }
    }
  }

  triggerOptionInfo(target) {
    if (target.closest('label').classList.contains('form__label')) {
      if (target.closest('button')?.id === 'size-guide') {
        document.querySelector('.size-guide').classList.add('open');
      } else {
        document.querySelector('.toothpaste-guide').classList.add('open');
      }
    }
  }
}
customElements.define('variant-option-buttons', VariantOptionButtons);

class SwatchSelect extends HTMLElement {
  constructor() {
    super();
    this.lastClick = window.performance.now();
  }

  connectedCallback() {
    this.addEventListener('click', this.clickHandler.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.clickHandler);
  }

  clickHandler(e) {
    if (!this.closest('card-product-wrapper')) return;

    e.stopPropagation();
    e.preventDefault();

    const { target } = e;

    const props = {
      self: this,
      productCard: this.closest('card-product-wrapper'),
      lastClickElapsed: () => window.performance.now() - this.lastClick,
    };

    const activeButton = e.target.closest('button');
    if (!activeButton) return;

    console.debug('SwatchSelect.clickHandler()', {
      props,
      activeButton,
      cardImage: props.productCard.querySelector('picture'),
      srcSet: activeButton.dataset.imageSrcSet,
      detail: this.closest('details'),
    });

    console.debug('lastClickElapsed', props.lastClickElapsed());

    // Keep the submenu details open when clicking on the swatch buttons
    if (this.closest('details')) {
      // debounce clicks, TODO: queue instead of debounce
      if (props.lastClickElapsed() < 500) return;
      this.lastClick = window.performance.now();

      function waitForAttributeChange(menuDetailsId) {
        return new Promise((resolve) => {
          const observer = new MutationObserver((mutationList, observer) => {
            for (const mutation of mutationList) {
              if (mutation.attributeName === 'open') {
                observer.disconnect();
                resolve(document.getElementById(menuDetailsId));
              }
            }
          });

          observer.observe(document.getElementById(menuDetailsId), { attributes: true, childList: false });
        });
      }

      // Keep the submenu drawer open
      let submenuDetails = document.getElementById(this.closest('details').id);
      submenuDetails.closest('ul.menu-drawer__menu').classList.add('submenu-open');
      submenuDetails.classList.add('menu-opening');
      submenuDetails.querySelector('summary').setAttribute('aria-expanded', 'true');

      // Ensure the open attribute is added back after it is removed by Shopify theme native scripts
      waitForAttributeChange(this.closest('details').id).then((element) => {
        element.setAttribute('open', null);
      });
    }

    props.self.querySelector('button.selected')?.classList.remove('selected');
    e.target.closest('button').classList.add('selected');

    props.productCard.querySelector('.loading__spinner').classList.remove('hidden');
    props.productCard.querySelector('picture img').onload = () => {
      props.productCard.querySelector('.loading__spinner').classList.add('hidden');
    };
    props.productCard.querySelector('picture source').setAttribute('srcSet', activeButton.dataset.imageSrcSet);
    props.productCard.querySelector('picture img').setAttribute('src', activeButton.dataset.imageSrc);
    props.productCard.querySelector('picture img').setAttribute('alt', activeButton.dataset.imageAlt);
  }
}
customElements.define('swatch-select', SwatchSelect);

(function () {
  // listen for clicks to "continue shopping links"
  document.addEventListener('click', (e) => {
    if (e.target.closest('.continue-shopping-link')) {
      if (window?.pdp || window.location.pathname === '/collections/all') {
        e.preventDefault();
        // console.debug('continue-shopping-link click', { event: e });
        document.querySelector('cart-drawer').close();
      }
    }
    if (e.target.closest('.option-guide-trigger')) {
      let guide = e.target.closest('.option-guide-trigger').id;
      document.querySelector(`.${guide}`).classList.add('open');
    }
  });
})();

(function () {
  document.addEventListener('click', (e) => {
    if (e.target.closest(`.toothpaste-type-select input[type='radio']:checked`)) {
      const currentFlavor = document.querySelector(
        'variant-selects [data-option-name] input:checked[data-flavor]'
      ).value;
      const currentType = e.target.closest(`.toothpaste-type-select  input[type='radio']:checked`).id;
      console.debug({
        target: e.target.closest(`.toothpaste-type-select input[type='radio']:checked`),
        currentFlavor: currentFlavor.toLowerCase().trim(),
        currentType,
      });

      if (currentType !== currentFlavor.toLowerCase().trim().split(' ')[1]) {
        console.warn('mismatched types');

        document
          .querySelector(
            `input[data-flavor="${
              currentFlavor.toLowerCase().trim().split(' ')[0]
            }"][data-toothpaste-type="${currentType}"]+label`
          )
          .click();
      }
    }
  });
})();

document.addEventListener('click', (e) => {
  if (e.target.closest('.index-hero-banner .banner__content')) {
    console.debug('clicked hero banner');
    if (e.target.closest('.index-hero-banner .banner__content').querySelector('.button--primary')) {
      window.location.href = e.target.querySelector('.button--primary').getAttribute('href');
    }
  }
});
